import type { MakeRequest } from "./types/MakeRequest";
import type { Options } from "./types/Options";

export const makeDelete =
  ({ makeRequest }: { makeRequest: MakeRequest }) =>
  (url: string, options: Options = {}) => {
    options.method = "delete";

    return makeRequest(url, options);
  };
